module.exports = __webpack_public_path__ + "static/media/bassProStore.c44cb5e4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/optimized/bassProStore.webp
// module id = 243
// module chunks = 0